import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-banner-nudge',
  templateUrl: './banner-nudge.component.html',
  styleUrls: ['./banner-nudge.component.less']
})
export class BannerNudgeComponent {
  @Output() onCloseNudge: EventEmitter<any> = new EventEmitter();
  @Input() bannerColorHex: string;
  @Input() bannerMessageText: string;
  @Input() bannerTextColorHex: string;

  close() {
    this.onCloseNudge.emit();
  }
}
